import { Button } from '@chakra-ui/button'
import { FormControl, FormLabel } from '@chakra-ui/form-control'
import { Input } from '@chakra-ui/input'
import { Box, Flex } from '@chakra-ui/layout'
import { Select } from '@chakra-ui/select'
import InputFloating from '../../../../components/InputFloating'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useContasReceber } from '../contexts/ContasReceberProvider'
import { useEffect } from 'react'
import { baseURL } from '../../../../services/api'
import { useState } from 'react'

const schema = yup.object().shape({
  numero_pedido: yup.string().test('len', 'Mínimo 6 caracteres', (val) => {
    if (val) {
      return val.length >= 6
    }
    return true
  }),
})

export function Filtro() {
  const { handleSubmit, register, formState, watch, setValue } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      pendente: 'A',
    },
  })

  const pendente = watch('pendente')
  const empresa = watch('empresa')
  const data_entrada = watch('data_entrada')
  const data_saida = watch('data_saida')
  const numero_pedido = watch('numero_pedido')
  const numero_nfe = watch('numero_nfe')

  // useEffect(() => {
  //   setValue("pendente", "A")
  // }, [])

  const [enterprise, setEnterprise] = useState([])

  const {
    getInfoContasReceber,
    loading,
    setPendencia,
    setEmpresa,
    setDataFiltro,
  } = useContasReceber()

  useEffect(() => {
    setPendencia(pendente)
    setEmpresa(empresa)
    setDataFiltro({
      dataEntrada: data_entrada,
      dataSaida: data_saida,
      numeroPedio: numero_pedido,
      numeroNfe: numero_nfe,
    })
  }, [pendente, empresa, data_entrada, data_saida, numero_pedido, numero_nfe])

  function filterContasReceber(data) {
    console.log(data)
    getInfoContasReceber(data)
  }

  async function getSelectOptionsEnterprise() {
    const response = await baseURL.get('/pedido/lista-empresas')

    setEnterprise(response.data)
  }

  useEffect(() => {
    getSelectOptionsEnterprise()
  }, [])

  return (
    <FormControl
      py="1rem"
      as="form"
      onSubmit={handleSubmit(filterContasReceber)}
      mt="1rem"
    >
      <Flex
        flexDir="column"
        align="center"
        w="full"
        px="6rem"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Flex align="start" justify="space-between" gap="1rem" w="full">
          <Flex gap="4rem">
            <Flex alignItems="start" flexDir="column">
              <InputFloating
                type="number"
                label="Numero nfe"
                variant="flushed"
                {...register('numero_nfe')}
                error={formState.errors.numero_nfe}
              />
            </Flex>
            <Flex alignItems="start" flexDir="column">
              <InputFloating
                type="number"
                label="Nº Pedido"
                variant="flushed"
                {...register('numero_pedido')}
                error={formState.errors.numero_pedido}
              />
            </Flex>
          </Flex>
          <Box
            display="flex"
            flex={1}
            minW="400px"
            gap="1rem"
            alignItems="start"
            justifyContent="center"
          >
            <Flex alignItems="start" flexDir="column">
              <InputFloating
                label="De:"
                type="date"
                {...register('data_entrada')}
                variant="flushed"
              />
            </Flex>
            <Flex ml="50px" alignItems="start" flexDir="column">
              <InputFloating
                label="Até:"
                type="date"
                {...register('data_saida')}
                variant="flushed"
              />
            </Flex>
          </Box>

          <Box display="flex" alignItems="start" h="full" gap="10rem">
            <Flex alignItems="center" gap="1rem">
              <label htmlFor={''}>Empresa:</label>
              <Flex alignItems="start" flexDir="column">
                <Select
                  placeholder="Selecione"
                  {...register('empresa')}
                  maxWidth="150px"
                >
                  {enterprise.map((item) => (
                    <option key={item.nome_empresa} value={item.nome_empresa}>
                      {item.nome_empresa}
                    </option>
                  ))}
                </Select>
              </Flex>
            </Flex>
          </Box>
          <Box display="flex" alignItems="start" h="full" gap="10rem">
            <Flex alignItems="center" gap="1rem">
              <label htmlFor={''}>Status:</label>
              <Flex alignItems="start" flexDir="column">
                <Select
                  placeholder="Selecione"
                  {...register('pendente')}
                  defaultValue="A"
                >
                  <option value="N">Pago</option>
                  <option value="S">Em aberto</option>
                  <option value="A">Atrasado</option>
                  <option value="AR">A Receber</option>
                </Select>
              </Flex>
            </Flex>
          </Box>
        </Flex>
        <Button
          colorScheme="blue"
          variant="outline"
          mt="1rem"
          type="submit"
          px="2rem"
          bg="#378BBF"
          color="white"
          _hover={{ bg: '#378BBF' }}
          isLoading={formState.isSubmitting || loading}
        >
          Filtrar
        </Button>
      </Flex>
    </FormControl>
  )
}
